// Ruta: apps/dashboard/src/pages/auth/UnauthorizedPage.tsx

import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ShieldOff } from 'lucide-react'
import { Button } from '@heyshaker/ui'

export function UnauthorizedPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="text-center space-y-6 max-w-md">
        <ShieldOff className="h-16 w-16 text-muted-foreground mx-auto" aria-hidden="true" />
        <div>
          <h1 className="text-2xl font-bold text-foreground">Sin acceso</h1>
          <p className="text-muted-foreground mt-2">
            No tienes permisos para acceder a esta sección.
            Contacta al administrador si crees que esto es un error.
          </p>
        </div>
        <div className="flex gap-3 justify-center">
          <Button variant="outline" onClick={() => navigate(-1)}>
            Volver
          </Button>
          <Button onClick={() => navigate('/overview')}>
            Ir al inicio
          </Button>
        </div>
      </div>
    </div>
  )
}
